/**
 * Shared byte-level Base64 helpers used by managers that serialise Loro
 * cursors and other small binary payloads as ASCII-safe strings.
 */
/** Encode a byte array to a Base64 string using the standard alphabet. */
export function b64(bytes) {
    let s = '';
    const CHUNK = 0x80_00;
    for (let i = 0; i < bytes.length; i += CHUNK) {
        s += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
    }
    return btoa(s);
}
/** Decode a Base64 string produced by {@link b64} back into a byte array. */
export function unb64(text) {
    const bin = atob(text);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++)
        out[i] = bin.charCodeAt(i);
    return out;
}
//# sourceMappingURL=base64.js.map